function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { MONDAY_LOGO_SMALL_SRC } from "constants/links";
import PictureComponent from "components/core/picture/picture-component";
import { EMBEDDED_BOARD_INITIAL_INTERACTION } from "/constants/bigbrain-event-types";
import TooltipComponent from "components/enhancements/tooltip/tooltip-component";
import { DARK_THEME } from "components/enhancements/tooltip/tooltip-constants";
import { getCookie } from "/services/cookies-service";
import { ALWAYS_FS } from "constants/cookies";
import { addParamToURL, getUrlParamValue, getLastPartOfUrl } from "utils/url";
import { StyledEmbeddedBoard } from "./embedded-board.scss";
import DefaultProps from "./default-props";
const IFRAME_CLASS_NAME = "board-iframe";
const FULL_STORY_EMBEDDED_PARAM = "fullstory";
const PLATFORM_REGION_PARAM_NAME = "r";
const IS_LIVE_BOARD_PLATFORM_PARAM = "live_board";
class EmbeddedBoard extends PureComponent {
    componentDidMount() {
        window.addEventListener("blur", this.blurAction);
    }
    componentWillUnmount() {
        window.removeEventListener("blur", this.blurAction);
    }
    render() {
        const { hideTopFrame } = this.props;
        return /*#__PURE__*/ _jsxs(StyledEmbeddedBoard, {
            className: "embedded-board",
            children: [
                this.renderTooltipIfNeeded(),
                /*#__PURE__*/ _jsxs("div", {
                    className: "embedded-wrapper",
                    children: [
                        !hideTopFrame && /*#__PURE__*/ _jsx("div", {
                            className: "embedded-board-top-frame",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "powered-by-wrapper",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        children: "Powered by"
                                    }),
                                    /*#__PURE__*/ _jsx(PictureComponent, {
                                        src: MONDAY_LOGO_SMALL_SRC,
                                        className: "monday-logo-image"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "board-iframe-content-wrapper",
                            children: /*#__PURE__*/ _jsx("iframe", {
                                src: this.getIframeUrl(),
                                className: IFRAME_CLASS_NAME
                            })
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "getBoardEmbeddedURL", ()=>{
            const { sharableLink, boardIdAndToken, isLiveBoard } = this.props;
            let boardIdAndTokenProp = boardIdAndToken; // Old prop support
            let region;
            if (sharableLink) {
                region = getUrlParamValue(sharableLink, PLATFORM_REGION_PARAM_NAME);
                boardIdAndTokenProp = getLastPartOfUrl(sharableLink);
            }
            let url = `https://view.monday.com/embed/${boardIdAndTokenProp}?hide_footer=true&allow_edit=true`;
            if (region) {
                url = addParamToURL(url, PLATFORM_REGION_PARAM_NAME, region);
            }
            if (isLiveBoard) {
                url = addParamToURL(url, IS_LIVE_BOARD_PLATFORM_PARAM, "true");
            }
            return url;
        });
        _define_property(this, "getIframeUrl", ()=>{
            let url = this.getBoardEmbeddedURL();
            const fullStoryActiveForPage = !!getCookie(ALWAYS_FS);
            if (fullStoryActiveForPage) {
                url = addParamToURL(url, FULL_STORY_EMBEDDED_PARAM, true);
            }
            return url;
        });
        _define_property(this, "blurAction", ()=>{
            if (document.getElementsByClassName(IFRAME_CLASS_NAME)[0] === document.activeElement) {
                const { boardIdAndToken } = this.props;
                BigBrain("track", EMBEDDED_BOARD_INITIAL_INTERACTION, {
                    info1: boardIdAndToken
                });
                this.setState({
                    showTooltip: false
                });
                window.removeEventListener("blur", this.blurAction);
            }
        });
        _define_property(this, "renderTooltipIfNeeded", ()=>{
            const { showTooltip } = this.state;
            const { tooltipText } = this.props;
            if (!showTooltip) return null;
            return /*#__PURE__*/ _jsx("div", {
                className: "tooltip-wrapper",
                children: /*#__PURE__*/ _jsx(TooltipComponent, {
                    theme: DARK_THEME,
                    children: tooltipText
                })
            });
        });
        this.state = {
            showTooltip: !!props.tooltipText
        };
    }
}
export { EmbeddedBoard as default };
EmbeddedBoard.defaultProps = DefaultProps;
